export default [
    {
        value: "ImpactosAmbientais",
        text: "Possibilidade de impactos ambientais(Água, Ar, Solo)"
    },
    {
        value: "DiversificacaoMatrizEnergetica",
        text: "Possibilidade de diversificação de matriz energética"
    },
    {
        value: "DesenvolvimentoNovaAtividadeEconomica",
        text: "Possibilidade de desenvolvimento de nova atividade socioeconômica"
    },
    {
        value: "ImpactosSegurancaQualidadeVidaComunidade",
        text: "Possibilidade d impactos na segurança ou qualidade de vida da comunidade"
    },
]